import type { ScaleHubProgress } from "./scaleHubTypes";

const STORAGE_KEY = "bordona-scale-hub-progress";

export const defaultScaleHubProgress: ScaleHubProgress = {
  completedCardIds: [],
  completedAt: {},
};

export function loadScaleHubProgress(): ScaleHubProgress {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaultScaleHubProgress;
    const p = JSON.parse(raw) as Partial<ScaleHubProgress>;
    return {
      completedCardIds: Array.isArray(p.completedCardIds) ? p.completedCardIds : [],
      completedAt: p.completedAt && typeof p.completedAt === "object" ? p.completedAt : {},
    };
  } catch {
    return defaultScaleHubProgress;
  }
}

export function saveScaleHubProgress(progress: ScaleHubProgress): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(progress));
  } catch {
    /* quota */
  }
}

export function markScaleHubCardComplete(
  progress: ScaleHubProgress,
  cardId: string
): ScaleHubProgress {
  const completedCardIds = progress.completedCardIds.includes(cardId)
    ? progress.completedCardIds
    : [...progress.completedCardIds, cardId];
  return {
    completedCardIds,
    completedAt: { ...progress.completedAt, [cardId]: Date.now() },
  };
}
